// store/index.js
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { injectStore } from '@/services/axios';
import categoriesReducer from '../reducers/categories-reducer';
import productViewOptionReducer from '../reducers/product-view-option-reducer';
import globalSettingsReducer from '../reducers/global-settings-reducer';
import globalPopupsReducer from '../reducers/global-popups-reducer';
import productsReducer from '../reducers/products-reducer';
import productRatingReducer from '../reducers/product-rating-reducer';
import cartsReducer from '../reducers/carts-reducer';
import authReducer from '../reducers/auth-reducer';
import storeLocatorReducer from '../reducers/store-locator-reducer';
import productDetailReducer from '../reducers/product-detail-reducer';
import breadcrumbReducer from '../reducers/breadcrumb-reducer';
import productComparisonReducer from '../reducers/product-comparison-reducer';
import cartModalReducer from '../reducers/cart-modal-reducer';
import justForYouReducer from '../reducers/just-for-you-reducer';
import sectionsReducer from '../reducers/sections-reducer';
import contentsReducer from '../reducers/contents-reducer';
import wishlistReducer from '../reducers/wishlist-reducer';
import shippingAddressReducer from '../reducers/shipping-address-reducer';
import myProfileReducer from '../reducers/my-profile-reducer';
import wishlistModalReducer from '../reducers/wishlist-modal-reducer';
import orderReducer from '../reducers/orders-reducer';
import checkoutSummaryReducer from '../reducers/checkout-summary-reducer';
import FAQTopicsReducer from '../reducers/faq-topics-reducer';
import FAQsReducer from '../reducers/faqs-reducer';
import similarProductsReducer from '../reducers/similar-products-reducer';
import placeOrderReducer from '../reducers/place-order-reducer';
import helpRequestReducer from '../reducers/help-request-reducer';
import chatLinkReducer from '../reducers/chat-link-reducer';
import searchReducer from '../reducers/search-reducer';
import campaignProductsReducer from '../reducers/campaign-products-reducer';
import frequentlyBoughtTogetherReducer from '../reducers/frequently-bought-together-reducer';
import suggestedItemsReducer from '../reducers/suggested-items-reducer';
import trendingCategoriesReducer from '../reducers/trending-categories-reduce';
import recentlyViewedReducer from '../reducers/recently-viewed-reducer';
import investorRelationsReducer from '../reducers/investor-relations-reducers';
import spinTheWheelReducer from '../reducers/spin-the-wheel-reducer';
import hamburgerMenuReducer from '../reducers/hamburger-menu-reducer';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: [
    'auth',
    'carts',
    'productComparison',
    'myProfile',
    'products',
    'shippingAddress',
    'orders',
    'checkoutSummary',
    'sections',
    'placeOrder',
    'campaignProducts', // TODO: will remove later
    'recentlyViewed',
    'productViewOption',
    // 'spinTheWheel', // TODO: check if everything is okay then use otherwise remove
  ], // Specify reducers to persist
  // serialize: true, // Enable serialization
  // timeout: 0, // Set timeout to prevent serialization timeout
};

const rootReducer = {
  categories: categoriesReducer,
  globalSettings: globalSettingsReducer,
  productRating: productRatingReducer,
  products: productsReducer,
  popups: globalPopupsReducer,
  carts: cartsReducer,
  auth: authReducer,
  storeLocator: storeLocatorReducer,
  productDetail: productDetailReducer,
  breadcrumb: breadcrumbReducer,
  productComparison: productComparisonReducer,
  cartModal: cartModalReducer,
  justForYou: justForYouReducer,
  sections: sectionsReducer,
  contents: contentsReducer,
  wishlist: wishlistReducer,
  shippingAddress: shippingAddressReducer,
  myProfile: myProfileReducer,
  wishlistModal: wishlistModalReducer,
  orders: orderReducer,
  checkoutSummary: checkoutSummaryReducer,
  FAQTopics: FAQTopicsReducer,
  FAQs: FAQsReducer,
  similarProducts: similarProductsReducer,
  placeOrder: placeOrderReducer,
  helpRequest: helpRequestReducer,
  chatLink: chatLinkReducer,
  search: searchReducer,
  campaignProducts: campaignProductsReducer,
  frequentlyBoughtTogether: frequentlyBoughtTogetherReducer,
  suggestedItems: suggestedItemsReducer,
  trendingCategories: trendingCategoriesReducer,
  recentlyViewed: recentlyViewedReducer,
  investorRelations: investorRelationsReducer,
  spinTheWheel: spinTheWheelReducer,
  productViewOption: productViewOptionReducer,
  hamburgerMenu: hamburgerMenuReducer,
};

const persistedReducer = persistReducer(
  persistConfig,
  combineReducers(rootReducer),
);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Required for redux-persist
    }),
});

export const persistor = persistStore(store);
injectStore(store);
export default store;
